<template>
  <article>
    <div class="firstPic leftTextArea">
      <div class="textHolder">
        <h2>Beauty</h2>
        <p>
          Ik heb ervoor gekozen om alle verzorgingen net iets meer te laten zijn
          dan een klassieke verzorging. Wellness en relaxatie zijn zeker even
          belangrijk dan de kwaliteit van de verzorgingen. Bij Yon-Ka zijn we
          ervan overtuigd dat schoonheid schuilt in fysieke en mentale harmonie.
          Daarom is elke behandeling ontwikkelt als een unieke,
          multi-zintuiglijke en diep persoonlijke ervaring. De geest wordt
          gerevitaliseerd en opnieuw verbonden met het lichaam, het bevrijdt
          spanning en laat ons het plezier van het leven opnieuw herontdekken.
        </p>
      </div>
      <img :src="Beauty" alt="Beauty" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Gelaatsverzorging</h2>
        <p>
          Een AANRADER voor iedereen. Je komt in de wereld van Yon-Ka producten,
          waar een heel verzorgritueel met aangepaste muziek je meeneemt door
          verschillende geuren en handelingen, met een heerlijke natuurlijke
          thee, waardoor je na deze verzorging helemaal ontspannen en verzorgd
          bent, zowel lichamelijk als geestelijk. Een complete en uitgebreide
          gelaatsverzorging met zo veel meer! We starten altijd eerst met 'Le
          Grand Classique' - verzorging van Yon-Ka om dan verder op maat te
          werken Tarief: vanaf € 75.
        </p>
      </div>
      <img :src="verzorging" alt="verzorging" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Yon-Ka</h2>
        <p>
          Gelaatsverzorgingen van Yon-Ka zijn unieke, aangepaste verzorgingen
          waarin zowel de kwaliteit van de verzorging als wellness, relaxatie en
          ontspanning belangrijk zijn.
        </p>
        <ul>
          <li>Le Grand Classique 75min (Iconische) - €95</li>
          <li>Vital Defense 60min (Essentiele) - €85</li>
          <li>Hydralessence 60min (Essentiele) - €85</li>
          <li>Hydrasun 60min (Essentiele) - €85</li>
          <li>Nutrilessence 60min (Essentiele) - €85</li>
          <li>Calmessence 60min (Essentiele) - €85</li>
          <li>Plaisir d'aromes 60min (Wellness) - €75</li>
          <li>Eclat cocoon 60min (Wellness) - €80</li>
        </ul>
      </div>
      <img :src="lavendel" alt="Yon-Ka" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Mahana-verzorging</h2>
        <ul>
          <li>Hydraterende gelaatsverzorging.</li>
          <li>Uitgebreide gelaat,-nek,-schouder en trapeziusmassage.</li>
          <li>
            Mahana-ster massage d.w.z massage van de hoofd (*kruin), de handen
            en de voeten met manuele massage, warme compressen en hotstones.
          </li>
          <li>
            Een mentale "ontspanningsreis"met muziek & geuren zorgt voor een
            totaalbeleving van ontspanning en wellness.
          </li>
          <li>110 €, 80 min.</li>
        </ul>
      </div>
      <img :src="Mahana" alt="Mahana" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Pedicure</h2>
        <p>
          Een voetverzorging die ook meer is dan de gewone klassieke pedicure.
          Ook hier wordt op wellness en relaxatie ingezet en start elke
          voetverzorging met een voetbad en voetscrub. Daarna volgt de
          voetverzorging en sluiten we af met een voetmassage en warme
          voetcompressen. <br />
          Tarief: € 30 gedurende 45 min, lakken € 5 extra.
        </p>
      </div>
      <img :src="pedicure" alt="pedicure" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Ontharingen</h2>
        <p>Ontharingen gebeuren met striphars en filmhars.</p>
        <ul>
          <li>Onderbenen en knie € 25.</li>
          <li>Volledige benen € 40.</li>
          <li>Bikinilijn tot aan sliprandje € 10.</li>
          <li>oksels € 10.</li>
          <li>wenkbrauwen € 10 met pincet.</li>
          <li>bovenlip € 10.</li>
        </ul>
      </div>
      <img :src="ontharingen" alt="ontharingen" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Manicure</h2>
        <p>
          Een hand-en nagelverzorging met een extra scrub en massage van hand-en
          onderarm. Tarief: Lakken inclusief € 25 gedurende 35 min.
        </p>
      </div>
      <img :src="manicure" alt="manicure" class="picHolder" />
    </div>

    <div class="lastPic rightTextArea">
      <div class="textHolder">
        <h2>Afwezigheid</h2>
        <p>
          Beste klanten, Bij afwezigheid vraag ik je steeds om 24u voor de
          afspraak te verwittigen, zoniet zal er een bedrag van 20 euro worden
          aangerekend.
        </p>
      </div>
      <img :src="afw" alt="body" class="picHolder" />
    </div>
  </article>
</template>

<script>
import Beauty from '../assets/beautyN.webp';
import verzorging from '../assets/gelaatN.webp';
import pedicure from '../assets/pedic.webp';
import manicure from '../assets/mani.webp';
import ontharingen from '../assets/ontharingN.webp';
import lavendel from '../assets/lavendel.webp';
import afw from '../assets/vase.webp';
import Mahana from '../assets/mahana.webp';
export default {
  name: 'Beauty',
  data() {
      return {
        Beauty: Beauty,
        verzorging: verzorging,
        pedicure: pedicure,
        manicure: manicure,
        ontharingen: ontharingen,
        lavendel: lavendel,
        afw: afw,
        Mahana: Mahana,
      }
    },
};
</script>

<style lang="scss" scoped>
</style>
